module.exports = __webpack_public_path__ + "static/img/医院信息化项目管理系统安卓APP.30f26f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/医院信息化项目管理系统安卓APP.png
// module id = ZXnJ
// module chunks = 1